import axios from "axios";

const REJECT_MSG_LIST_URL =  "api/v1/rxview/rejectMessages"

// gets the reject msg chosen
export const getRejectMsg = async (claimId, claimSeqNum) => {
    const { data } = await axios.get(REJECT_MSG_LIST_URL + `?claimId=${encodeURIComponent(claimId)}` + `&claimSequenceNumber=${encodeURIComponent(claimSeqNum)}`) 
    // console.log(data);
    return data
}